import CrossIcon from "../../assets/images/CrossIcon";
import {
  StaffListConstants,
} from "../../constants/constants";
import Button from "./cta/Button";
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";
import PassiveModeIcon from "../../assets/images/PassiveModeIcon";
import StaffExitIcon from "../../assets/images/StaffExitIcon";
import StaffExitFlowUnSelectedRadioButton from "../../assets/images/StaffExitFlowUnSelectedRadioButton copy";
import StaffExitFlowSelectedRadioButton from "../../assets/images/StaffExitFlowSelectedRadioButton";
import { useTranslation } from "react-i18next";

interface ModalProps {
  selectedExitFlowMethod: any;
  setSelectedExitFLowMethod: any;
  OnExitFlowPopUpClose: any;
  OnExitFlowPopUpContinue: any;
  style?: any;
}

export const PopUpModelForStaffExitFlow = ({
  selectedExitFlowMethod,
  setSelectedExitFLowMethod,
  OnExitFlowPopUpClose,
  OnExitFlowPopUpContinue,
  style
}: ModalProps) => {
  const { t, i18n } = useTranslation();
  const staffExitFlowArray = [
    // "Move staff to Passive Mode",
    t('staffExitProcess'),
  ];
  const selectedStaffExitMethodContainer =
    "bg-sideMenubackground flex flex-col items-center py-[2vh]  border rounded-lg  border-primary w-1/2";
  const unSelectedStaffExitMethodContainer =
    "flex flex-col items-center py-[2vh]  cursor-pointer rounded-lg border border-border w-1/2";
  const selectedStaffExitMethodTextBox =
    " selectedRoleButton text-center text-primary pt-4 text-wrap";
  const unSelectedStaffExitMethodTextBox =
    " staffVerifyTitle text-center text-body1Regular pt-4 text-wrap";
  const iconMap: Record<number, React.ComponentType<any>> = {
    0:StaffExitIcon
    // 0: PassiveModeIcon,
    // 1: StaffExitIcon,
  };
  return ReactDOM.createPortal(
    <>
      <div className="fixed z-10 inset-0 overflow-y-auto ">
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-8 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-blackColor bg-opacity-35 "></div>
          </div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div
            className="inline-block align-bottom bg-whiteColor   rounded-lg text-left  shadow-xl transform transition-all  sm:align-middle "
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="px-8 py-8 ">
              <div
                className="flex justify-between  items-center"
                onClick={OnExitFlowPopUpClose}
              >
                <div className="staffVerifySubTitle text-body1Regular ">
                  {t('selectAnAction')}
                </div>
                <CrossIcon />
              </div>
              <div className="pt-8 pb-6 consentSucessDescription text-dashBoardTileCountColor">
                {/* {StaffListConstants.pleaseSelectAnyOneOptionToContinue} */}
              </div>

              <div className=" flex justify-center gap-4 ">
                {staffExitFlowArray.map((data: any, index: number) => {
                  const Icon = iconMap[index];
                  const color =
                    selectedExitFlowMethod === index ? "white" : "#E9EEFE";
                  return (
                    <div
                      className={
                        selectedExitFlowMethod == index
                          ? selectedStaffExitMethodContainer
                          : unSelectedStaffExitMethodContainer
                      }
                      onClick={() => {
                        setSelectedExitFLowMethod(index);
                      }}
                    >
                      <div className="pt-6">
                        <Icon color={color} />
                      </div>

                      <div
                        className={
                          selectedExitFlowMethod == index
                            ? selectedStaffExitMethodTextBox
                            : unSelectedStaffExitMethodTextBox
                        }
                      >
                        {data}
                      </div>
                      <div className={`pb-4 ${index == 1 ? "pt-8" : "pt-4"}`}>
                        {selectedExitFlowMethod === index ? (
                          <StaffExitFlowUnSelectedRadioButton />
                        ) : (
                          <StaffExitFlowSelectedRadioButton />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div>
                {" "}
                <div className="flex justify-center items-center mt-8 ">
                  <div className="pr-7">
                    <Button
                      handleClick={OnExitFlowPopUpClose}
                      buttonText={t('cancel')}
                      className={
                        "py-3 px-9  mb-2 downloadSampleConsentText font-nunito text-primary border  border-primary bg-whiteColor rounded-lg"
                      }
                    />
                  </div>
                  <div>
                    <Button
                      buttonText={t('continue')}
                      handleClick={OnExitFlowPopUpContinue}
                      className="py-3 px-8 mb-2 downloadSampleConsentText text-white font-nunito  bg-primary rounded-lg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};
